import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENUITEMS.MENU.TEXT',
    //     isTitle: true
    // },
    {
        id: 2,
        label: 'Tableau de bord',
        icon: 'ri-dashboard-line',
        badge: {
            variant: 'success',
            text: '',
        },
        link: '/ikena'
    },

    {
        id: 3,
        label: 'Super Administrateurs',
        icon: 'ri-user-settings-fill',
          subItems: [
            {
                id: 10,
                label: 'Utlisateurs',
                link: '/ikena/list',
                parentId: 9
            },

              {
                id: 10,
                label: 'Commande Marketplace.',
                link: '/ikena/market-place-transactions-commande',
                parentId: 9
            },
            {
                id: 11,
                label: 'Marketplace Retrait',
                link: '/ikena/market-place-transactions-retrait',
                parentId: 9
            },


             {
                id: 12,
                label: 'Location Paiement',
                link: '/ikena/demande-location-transactions',
                parentId: 9
            },

        ]
    },
    {
        id: 4,
        label: 'Président coopérative',
        icon: 'ri-user-settings-fill',
        link: '/ikena/administrateurs'
    },
    {
        id: 5,
        label: 'Location machine',
        icon: ' ri-caravan-fill',
        link: '/ikena/locations-machines'
    },
    {
        id: 6,
        label: 'Coopératives',
        icon: 'ri-team-fill',
        link: '/ikena/cooperatives'
    },
    {
        id: 14,
        label: 'Agents',
        icon: 'ri-user-2-fill',
        link: '/ikena/agents'
    },

    {
        id: 14,
        label: 'Vendeurs',
        icon: 'ri-user-2-fill',
        link: '/ikena/vendeurs'
    },
    {
        id: 7,
        label: 'Membres',
        icon: 'ri-user-follow-fill',
        link: '/ikena/membres'
    },
    {
        id: 8,
        label: 'Stock',
        icon: 'ri-store-fill',  // Choisir ici l'icône la plus adaptée
        link: '/ikena/stock'
    },

    {

        id: 9,
        label: 'Paramétrage',
        icon: ' ri-tools-line',
        subItems: [
            {
                id: 10,
                label: 'Machines',
                link: '/ikena/parametre-machines',
                parentId: 9
            },
            {
                id: 11,
                label: 'Outils',
                link: '/ikena/parametre-produits',
                parentId: 9
            },

            {
                id: 10,
                label: 'Catégorit produit',
                link: '/ikena/categorie-produit',
                parentId: 9
            },
            {
                id: 12,
                label: 'Unités de mesure',
                link: '/ikena/parametre-unite-mesure',
                parentId: 9
            },
            {
                id: 13,
                label: 'Paramètre général',
                link: '/ikena/parametre-general',
                parentId: 9
            },

             {
                id: 14,
                label: 'Logs',
                link: '/ikena/logs',
                parentId: 9
            }
        ]
    },
  
];

